import React from "react";

export default function BsYoutube() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#m)">
        <path
          d="M12.076 3.082h.134c1.233.005 7.48.05 9.165.503a3.015 3.015 0 0 1 2.122 2.13c.152.57.259 1.324.33 2.103l.015.156.034.39.011.156c.098 1.37.11 2.655.111 2.935v.113a48.123 48.123 0 0 1-.123 3.09l-.012.157-.013.156c-.075.858-.186 1.71-.353 2.337a3.009 3.009 0 0 1-2.122 2.13c-1.74.468-8.354.501-9.27.503h-.213c-.463 0-2.38-.01-4.39-.078l-.255-.01-.131-.006-.256-.01-.257-.01c-1.665-.074-3.25-.193-3.981-.39A3.01 3.01 0 0 1 .5 17.307c-.167-.625-.278-1.479-.353-2.337l-.012-.158-.012-.155A47.099 47.099 0 0 1 0 11.604v-.185c.003-.322.015-1.437.096-2.667l.01-.154.005-.078.012-.156.033-.39.015-.156c.072-.779.178-1.535.33-2.103a3.01 3.01 0 0 1 2.123-2.13c.73-.195 2.315-.315 3.98-.39l.255-.011.258-.009.13-.004.256-.011c1.428-.046 2.856-.071 4.284-.076h.29v-.002ZM9.6 7.897v7.227l6.236-3.612L9.6 7.897Z"
          fill="#currentColor"
        />
      </g>
      <defs>
        <clipPath id="m">
          <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
